function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import * as LocalAuthentication from "expo-local-authentication";
import { Platform, Linking as RNLinking } from "react-native";
import Url from "url-parse";
import { APP_SLUG, LOADING_TIMEOUT } from "../constants";
import { CurrentUserQuery } from "../hooks/useCurrentUser.query";
import { preloadPersistedState, setPersistedState } from "../hooks/usePersistedState";
import { authClient } from "./auth";
import { initFonts } from "./initFonts";
import { addBreadcrumb, initAnalytics, setUserProperties } from "./log";
import LogBox from "./LogBox";
import { fetchIsConnected } from "./NetInfo";
import { initConfig } from "./remoteConfig";
import Sentry from "../sentry";
function getInitialURL() {
    return _getInitialURL.apply(this, arguments);
}
function _getInitialURL() {
    _getInitialURL = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        RNLinking.getInitialURL()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _getInitialURL.apply(this, arguments);
}
var hasSimulatedError = false;
function wrapInitStep(step, factory, errorValue) {
    return _wrapInitStep.apply(this, arguments);
}
function _wrapInitStep() {
    _wrapInitStep = _async_to_generator(function(step, factory, errorValue) {
        var start, result, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    start = Date.now();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    addBreadcrumb({
                        message: 'wrapInitStep:start ' + step
                    });
                    return [
                        4,
                        factory()
                    ];
                case 2:
                    result = _state.sent();
                    Sentry.addBreadcrumb({
                        message: 'wrapInitStep:success ' + step,
                        data: {
                            duration: Date.now() - start
                        }
                    });
                    return [
                        2,
                        result
                    ];
                case 3:
                    e = _state.sent();
                    Sentry.captureException(e, {
                        extra: {
                            initStep: step,
                            duration: Date.now() - start
                        }
                    });
                    Sentry.captureException(new Error("wrapInitStep:".concat(step, " failed")), {
                        extra: {
                            originalError: e,
                            duration: Date.now() - start
                        }
                    });
                    if (typeof errorValue !== 'undefined') {
                        return [
                            2,
                            errorValue
                        ];
                    }
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _wrapInitStep.apply(this, arguments);
}
function captureLocalAuthenticationTelemetry() {
    return _captureLocalAuthenticationTelemetry.apply(this, arguments);
}
function _captureLocalAuthenticationTelemetry() {
    _captureLocalAuthenticationTelemetry = _async_to_generator(function() {
        var _ref, localAuthEnrolledLevel, localAuthHardware, localAuthSupportedTypes, _, _tmp;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(Platform.OS !== 'web')) return [
                        3,
                        5
                    ];
                    _ = Promise.all;
                    return [
                        4,
                        LocalAuthentication.getEnrolledLevelAsync()
                    ];
                case 1:
                    _tmp = [
                        _state.sent()
                    ];
                    return [
                        4,
                        LocalAuthentication.hasHardwareAsync()
                    ];
                case 2:
                    _tmp = _tmp.concat([
                        _state.sent()
                    ]);
                    return [
                        4,
                        LocalAuthentication.supportedAuthenticationTypesAsync()
                    ];
                case 3:
                    return [
                        4,
                        _.apply(Promise, [
                            _tmp.concat([
                                _state.sent()
                            ])
                        ])
                    ];
                case 4:
                    _ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        3
                    ]), localAuthEnrolledLevel = _ref[0], localAuthHardware = _ref[1], localAuthSupportedTypes = _ref[2];
                    setUserProperties({
                        localAuthEnrolledLevel: localAuthEnrolledLevel,
                        localAuthHardware: localAuthHardware,
                        localAuthSupportedTypes: localAuthSupportedTypes
                    });
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _captureLocalAuthenticationTelemetry.apply(this, arguments);
}
export function initApp(apolloClient) {
    return _initApp.apply(this, arguments);
}
function _initApp() {
    _initApp = _async_to_generator(function(apolloClient) {
        var initialURL, query, isDetox, clearState, remoteConfigPromise, connectedPromise, preloadSeenLocalAuthenticationPromptPromise, fontPromise, fontTimeout, fontLoader, promise, timeoutPromise;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getInitialURL()
                    ];
                case 1:
                    initialURL = _state.sent();
                    query = new Url(initialURL, {}, {
                        parser: true
                    }).query;
                    isDetox = query.detox === 'true';
                    clearState = query.detoxClearState === 'true';
                    if (isDetox) {
                        global.e2e = true;
                        LogBox.ignoreAllLogs(true);
                    } else {
                        initAnalytics();
                    }
                    if (!clearState) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        authClient.signOut()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (!(query.detoxEmail && query.detoxPassword)) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        apolloClient.clearStore()
                    ];
                case 4:
                    _state.sent();
                    authClient.setAuthApolloClient(apolloClient);
                    return [
                        4,
                        authClient.login(query.detoxEmail, query.detoxPassword)
                    ];
                case 5:
                    _state.sent();
                    return [
                        4,
                        apolloClient.query({
                            query: CurrentUserQuery,
                            fetchPolicy: 'network-only'
                        })
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    if (query.skipLocalAuthenticationPrompt) {
                        setPersistedState('SeenLocalAuthenticationPrompt', JSON.parse(query.skipLocalAuthenticationPrompt));
                    }
                    if (global.e2e && !!query.minOuiAppVersion) {
                        setPersistedState('minOuiAppVersion', JSON.parse(query.minOuiAppVersion));
                    }
                    remoteConfigPromise = wrapInitStep('remoteConfig', initConfig);
                    connectedPromise = wrapInitStep('netInfo', function() {
                        return fetchIsConnected(5000);
                    });
                    // connectedPromise never rejects
                    void connectedPromise.then(function(isConnected) {
                        if (!isConnected) {
                            Sentry.addBreadcrumb({
                                message: 'NOT_CONNECTED_TO_INTERNET'
                            });
                        }
                    });
                    preloadSeenLocalAuthenticationPromptPromise = wrapInitStep('preloadSeenLocalAuthenticationPrompt', function() {
                        return preloadPersistedState('SeenLocalAuthenticationPrompt').then(function() {
                            return true;
                        });
                    }, true);
                    fontPromise = wrapInitStep('initFonts', function() {
                        return initFonts().then(function() {
                            // @ts-ignore
                            global.fontsLoaded = true;
                            return true;
                        });
                    }, true);
                    fontTimeout = new Promise(function(resolve) {
                        var timeout = setTimeout(function() {
                            Sentry.captureMessage('FONT_TIMEOUT');
                            resolve();
                        }, 2000);
                        // dont need to check rejection in the timeout race promise
                        void fontPromise.then(function() {
                            clearTimeout(timeout);
                        });
                    });
                    fontLoader = Promise.race([
                        fontPromise,
                        fontTimeout
                    ]);
                    if (query.detoxSimulateLoadingError && !hasSimulatedError) {
                        hasSimulatedError = true;
                        throw new Error('SIMULATED LOADING ERROR');
                    }
                    void captureLocalAuthenticationTelemetry();
                    promise = Promise.all([
                        fontLoader,
                        wrapInitStep('initAuth', function() {
                            return authClient.init(apolloClient, {
                                forceReauth: query.forceReauth
                            });
                        }),
                        connectedPromise,
                        preloadSeenLocalAuthenticationPromptPromise,
                        remoteConfigPromise
                    ]).then(function(param) {
                        var _param = _sliced_to_array(param, 3), _param_ = _param[1], isLoggedIn = _param_.isLoggedIn, reauthenticate = _param_.reauthenticate, isConnected = _param[2];
                        return {
                            isLoggedIn: isLoggedIn,
                            reauthenticate: reauthenticate,
                            isConnected: isConnected
                        };
                    });
                    timeoutPromise = new Promise(function(_, reject) {
                        var timeout = setTimeout(function() {
                            reject(new Error('LOADING_TIMEOUT'));
                        }, LOADING_TIMEOUT);
                        // dont need to check rejection in the timeout race promise
                        void promise.then(function() {
                            return clearTimeout(timeout);
                        });
                    });
                    return [
                        2,
                        Promise.race([
                            promise,
                            timeoutPromise
                        ])
                    ];
            }
        });
    });
    return _initApp.apply(this, arguments);
}
export function shouldShowWebBlocker() {
    return !global.e2e && Platform.OS === 'web' && [
        'oui-aviva'
    ].includes(APP_SLUG) && !window.location.hostname.includes('-dev-');
}
